var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup330(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_330",
    "data-name": "Group 330",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.681,
    height: 9.681,
    viewBox: "0 0 9.681 10.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 9.681,
    height: 9.681,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M50.509,306.279a.575.575,0,0,1-.4-.613c.006-.264,0-.528,0-.793a.547.547,0,0,1,.605-.6q3.765,0,7.53,0a.289.289,0,0,1,.27.119v.17a2.026,2.026,0,0,0,0,1.454c0,.088.034.21-.01.254s-.166.01-.254.01H50.509",
    transform: "translate(-48.847 -296.611)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M8.29,0a.257.257,0,0,1,.077.327,2.047,2.047,0,0,0,0,1.36c.068.2-.017.32-.23.32H.553A.542.542,0,0,1,0,1.605V.378A.6.6,0,0,1,.378,0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M0,203.3a.6.6,0,0,1,.229-.3.5.5,0,0,1,.267-.081q2.3,0,4.6,0c.083,0,.108.026.108.108,0,.34,0,.68,0,1.02a.286.286,0,0,0,.211.3.273.273,0,0,0,.2-.028c.143-.066.285-.132.427-.2a.161.161,0,0,1,.152,0c.147.071.295.142.445.206a.263.263,0,0,0,.384-.253c0-.343,0-.686,0-1.029,0-.093.026-.126.123-.125.343.005.686,0,1.029,0a.2.2,0,0,1,.208.286,2.12,2.12,0,0,0,0,1.433.207.207,0,0,1-.209.294H.6a.554.554,0,0,1-.6-.4Z",
    transform: "translate(0 -197.801)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M58.171,102.9a.245.245,0,0,1-.246.121q-3.8,0-7.6,0a.5.5,0,0,1-.549-.481,6.169,6.169,0,0,1,0-1.074.51.51,0,0,1,.517-.457c.249,0,.5,0,.746,0,.085,0,.108.033.107.112,0,.34,0,.68,0,1.02a.272.272,0,0,0,.413.27c.138-.061.275-.124.41-.192a.173.173,0,0,1,.169,0c.135.067.273.13.41.193a.277.277,0,0,0,.418-.262c0-.34,0-.68,0-1.02,0-.1.033-.122.125-.122q2.417,0,4.834,0a.271.271,0,0,1,.242.119v.17a2.026,2.026,0,0,0,0,1.454Z",
    transform: "translate(-48.502 -98.466)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M126.869,101.039c.091,0,.182,0,.274,0,.063,0,.093.024.093.088,0,.189,0,.377,0,.566,0,.059-.024.082-.082.052l-.017-.008a.466.466,0,0,0-.546,0c-.076.049-.095.032-.1-.063,0-.179,0-.359,0-.538,0-.076.031-.1.1-.1.091,0,.182,0,.274,0",
    transform: "translate(-123.309 -98.494)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M228.34,202.921c.1,0,.195,0,.292,0,.056,0,.08.022.079.078,0,.192,0,.383,0,.575,0,.058-.022.075-.075.049a.429.429,0,0,1-.042-.02.438.438,0,0,0-.5,0c-.119.069-.129.057-.129-.078,0-.163,0-.327,0-.49,0-.079.023-.116.108-.11s.176,0,.264,0Z",
    transform: "translate(-222.229 -197.809)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup330);
export default __webpack_public_path__ + "static/media/Group330.abf450be510ae5d100279f982c8a49b1.svg";
export { ForwardRef as ReactComponent };